/* @generated */

// ../src/click_outside/click_outside.tsx
import classNames from "classnames";
import * as React from "react";
import { ELEVATED_BACKDROP_INDEX, Layer } from "@dropbox/dig-components/layer";

// ../src/click_outside/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var backdrop = "dig-8710qs0_21-1-1";
var clickOutside = _7a468({ defaultClassName: "dig-8710qs1_21-1-1", variantClassNames: { isBlock: { true: "dig-8710qs2_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });

// ../src/click_outside/click_outside.tsx
var ClickOutside = ({
  onClickOutside,
  shouldPropagateMouseEvents = false,
  isClickThroughPortaled = true,
  children,
  isBlock = false,
  isActive = false,
  shouldClickOutsideWhenDefaultPrevented = true,
  className,
  ...rest
}) => {
  const cls = classNames("dig-ClickOutside", clickOutside({ isBlock }), {
    "dig-ClickOutside--block": isBlock
  });
  const layerClass = classNames("dig-ClickOutside--backdrop", backdrop, className);
  const inProgressTimeout = React.useRef(null);
  const isClickedInside = React.useRef(false);
  const captureInside = () => {
    isClickedInside.current = true;
  };
  const handleClickLayer = () => {
    isClickedInside.current = false;
  };
  const handleClose = React.useCallback(
    (e) => {
      const handleCloseLogic = () => {
        if (!shouldClickOutsideWhenDefaultPrevented && e.defaultPrevented) {
          return;
        }
        const targetIsLabel = e.target && e.target instanceof Element && e.target.tagName === "LABEL";
        if (targetIsLabel) {
          return;
        }
        if (isClickedInside.current) {
          isClickedInside.current = false;
          return;
        }
        if (onClickOutside)
          onClickOutside(e);
      };
      setTimeout(handleCloseLogic, 0);
    },
    [onClickOutside, shouldClickOutsideWhenDefaultPrevented]
  );
  const setup = React.useCallback(() => {
    inProgressTimeout.current = setTimeout(() => {
      isClickedInside.current = false;
      document.addEventListener("click", handleClose, { capture: true });
      document.addEventListener("contextmenu", handleClose, { capture: true });
      inProgressTimeout.current = null;
    }, 0);
  }, [handleClose, isClickedInside]);
  const cleanup = React.useCallback(() => {
    if (typeof inProgressTimeout.current === "number") {
      clearTimeout(inProgressTimeout.current);
      inProgressTimeout.current = null;
    }
    document.removeEventListener("click", handleClose, { capture: true });
    document.removeEventListener("contextmenu", handleClose, { capture: true });
  }, [handleClose]);
  React.useEffect(() => {
    if (isActive)
      setup();
    else
      cleanup();
    return () => cleanup();
  }, [isActive, onClickOutside]);
  return /* @__PURE__ */ React.createElement(
    "div",
    { onClickCapture: captureInside, onContextMenuCapture: captureInside, className: cls },
    // If click_outside is active and we do not want to propagate mouse events,
    // render a layer to swallow mouse events
    isActive && !shouldPropagateMouseEvents && /* @__PURE__ */ React.createElement(
      Layer,
      {
        _elevateByZ: ELEVATED_BACKDROP_INDEX,
        onClick: handleClickLayer,
        onContextMenu: handleClickLayer,
        isPortaled: isClickThroughPortaled,
        className: layerClass,
        "data-testid": "digClickOutsideisActiveLayer",
        ...rest
      }
    ),
    children
  );
};
ClickOutside.displayName = "ClickOutside";
export {
  ClickOutside
};
